import script from "./GalleryView.vue?vue&type=script&setup=true&lang=js"
export * from "./GalleryView.vue?vue&type=script&setup=true&lang=js"

import "./GalleryView.vue?vue&type=style&index=0&id=15d1b98e&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15d1b98e"]])

export default __exports__